import * as React from "react";

import { FEATURE_ACCESS, useFeatureAccess } from "../../hooks/useFeatureAccess";

import { LoadingSkeleton } from "./LoadingSkeleton";
import { RestrictedAccess } from "./RestrictedAccess";
import { StatusCard } from "./StatusCard";

import type { FeaturesConfigKey } from "../../constants/feature";

interface ConfigUIGateProps {
  feature: FeaturesConfigKey;
  children: React.ReactNode;
  description?: string;
  fallback?: React.ReactNode;
}

/** Gates a route or page region on a feature flag. Use ConfigUI for a button or menu entry. */
export const ConfigUIGate = ({
  feature,
  children,
  description = "This feature is not enabled for your organization. Please contact your administrator.",
  fallback = <LoadingSkeleton />,
}: ConfigUIGateProps) => {
  const access = useFeatureAccess(feature);

  if (access === FEATURE_ACCESS.LOADING) return <>{fallback}</>;
  if (access === FEATURE_ACCESS.ENABLED) return <>{children}</>;

  if (access === FEATURE_ACCESS.ERROR) {
    return (
      <StatusCard
        tone="error"
        title="Something went wrong"
        description="We could not check what your organization has access to. Refresh the page, and contact your administrator if this keeps happening."
      />
    );
  }

  return <RestrictedAccess description={description} />;
};
